"use strict";
/**
 * Text domain models
 * Pure data models without database-specific fields
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=text.js.map